import { useAuth } from '../utils/auth'
import classnames from 'classnames'
import styles from './_announcement.module.scss'
import { t } from '../utils/i18n'
import { isOnSmallPlan } from '../pages/lab/bonus'
import { labBonusPath } from '../utils/routeHelpers'
import Link from 'next/link'

const LabBenefitAnnouncement = () => {
  const { currentUser } = useAuth()

  const isSmallPlan = isOnSmallPlan(currentUser)
  const noticeText = isSmallPlan
    ? t('Activate Your FREE Worship Online BONUS')
    : t('Activate Your $177 Discount For Your Worship Online Subscription')

  return (
    <Link href={labBonusPath()}>
      <div className={classnames(styles.notice, styles.noticeGift)}>
        <p className={styles.noticeHeader}>{t('We have a gift for you!')}</p>
        <p className={styles.noticeTitle}>{noticeText}</p>
      </div>
    </Link>
  )
}

export default LabBenefitAnnouncement
